import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'
import { GROWER_SUB_USER, PROCESSOR_SUB_USER, RETAILER_SUB_USER } from '@/utils/roles'

export default {
  getSalesData: async ({ commit }, payload) => {
    const { limit, page, order, search } = payload
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get('/sales', {
        params: {
          limit,
          page,
          order,
          search
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'sales',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  totalInoviceData: async ({ commit }) => {
    try {
      const res = await axios.get('/sales/total-invoice-widget')
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'sale-list-dashboard',
        data: res.data.sales
      })
      return {
        data: res.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  paymentRecordDelete: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await await axios.delete(`/sales/${id}/delete-payment`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getSaleById: async ({ commit }, id) => {
    try {
      const res = await axios.get(`/sales/${id}`)
      commit('SET_STATE', {
        action: 'sale',
        data: res.data.sales
      })
      commit('SET_STATE', {
        action: 'salesItems',
        data: res.data.sales.salesItems
      })
      commit('SET_STATE', {
        action: 'salesPayments',
        data: res.data.sales.salesPayments
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },

  // get all customers (client + patient)
  // eslint-disable-next-line no-unused-vars
  async get_customers({ commit, dispatch, rootState }, payload) {
    try {
      let data = []
      let dataCount = 0
      if (GROWER_SUB_USER.includes(rootState.auth.user.roleId) || PROCESSOR_SUB_USER.includes(rootState.auth.user.roleId)) {
        const res = await dispatch('client/getClients', { ...payload, dropdownClientId: payload.customer }, { root: true })
        data = res.data.map(x => ({
          ...x,
          customer_type: 'client'
        }))

        dataCount += res.FilteredCount
      } else if (RETAILER_SUB_USER.includes(rootState.auth.user.roleId)) {
        const res = await dispatch('patient/getPatients', { ...payload, dropdownPatientId: payload.customer }, { root: true })
        data = res.data.map(x => ({
          ...x,
          customer_type: 'patient'
        }))

        dataCount += res.FilteredCount
      } else {
        let clients = await dispatch('client/getClients', { ...payload, dropdownClientId: payload.customer }, { root: true })
        let patient = await dispatch('patient/getPatients', { ...payload, dropdownPatientId: payload.customer }, { root: true })
        clients = clients.data.map(x => ({
          ...x,
          customer_type: 'client'
        }))

        // client count
        dataCount += clients.FilteredCount

        patient = patient.data.map(x => ({
          ...x,
          customer_type: 'patient'
        }))

        // patient count
        dataCount += patient.FilteredCount

        data = [...clients, ...patient]
      }

      // set customer list
      commit('SET_CUSTOMER_LIST', data)

      return { data, FilteredCount: dataCount }
    } catch (err) {
      return Promise.reject(err.response.data)
    }
  },

  // get customer pos history
  async get_customers_pos_hostory({ commit }, id) {
    try {
      commit('SET_STATE', {
        action: 'loading',
        data: true
      })

      const res = await axios.get(`/pos/customer-history/${id}`)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'customerLastPOSRecord',
        data: res.data.salesItems ? res.data.salesItems : []
      })

      return {
        sales: res.data.salesItems ? res.data.salesItems : [],
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return Promise.reject(err.response.data)
    }
  },

  // get product list by category
  async getByCategory({ commit }, payload) {
    try {
      commit('SET_STATE', {
        action: 'product_grid_loading',
        data: true
      })

      const res = await axios.get('/pos/pos-product-list', payload)

      // set loader
      commit('SET_STATE', {
        action: 'product_grid_loading',
        data: false
      })

      // set product list
      commit('SET_PRODUCT_LIST', {
        page: payload.params.page,
        data: res.data.products
      })

      // set product count
      commit('SET_STATE', {
        action: 'product_grid_count',
        data: res.data.totalCount
      })

      // set taxes
      commit('SET_STATE', {
        action: 'item__taxes',
        data: res.data.taxes
      })

      return JSON.parse(JSON.stringify(res.data))
    } catch (err) {
      commit('SET_STATE', {
        action: 'product_grid_loading',
        data: false
      })
      return Promise.reject(err.response.data)
    }
  },

  payPaymentById: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.put(`/sales/${id}/update-payment`, data)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },

  // create invoice
  async create_sale({ commit }, payload) {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    // send create sale request
    try {
      const res = await axios.post('/sales', payload)

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'products',
        data: []
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get invoice
  async get_invoice_by_id({ commit }, id) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get(`/sales/${id}`)

      commit('SET_STATE', {
        action: 'invoice',
        data: res.data.data
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // create hold invoice
  async create_hold_invoice({ commit }, payload) {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    // send create hold invoice request
    try {
      const res = await axios.post('/hold-sales', payload)

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'products',
        data: []
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get all hold invoices
  async get_all_hold_invoices({ commit }, payload) {
    const { limit, page, order, search } = payload

    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      // fetch invoices
      const res = await axios.get('/hold-sales', {
        params: {
          limit,
          page,
          order,
          search
        }
      })

      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // set Hold Invoices
      commit('SET_STATE', {
        action: 'holdInvoices',
        data: res.data.data
      })

      // set total result
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      // set filtered count
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })

      // return data
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // display msg
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // delete hold invoice by id
  async delete_hold_invoice_by_id({ commit }, id) {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.delete(`/hold-sales/${id}`)

      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // return data
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // display msg
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get hold invoice by id
  async get_hold_invoice_by_id({ commit }, id) {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      // fetch invoice
      const res = await axios.get(`/hold-sales/${id}`)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'invoice',
        data: res.data.holdSales
      })

      // return data
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // display error msg
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update hold invoice by id
  async update_hold_invoice({ commit }, { id, data }) {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    // send update hold invoice request
    try {
      const res = await axios.put(`/hold-sales/${id}`, data)

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'products',
        data: []
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // create sales return invoice
  async create_sale_return_invoice({ commit }, payload) {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    // send create sales return request
    try {
      const res = await axios.post('/sales-return', payload)

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  async deleteSaleRecord({ commit }, { id }) {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.delete(`sales/${id}`)

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // return data
      return {
        message: res.data.message
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // display msg
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}
